import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAnalytics } from './useAnalytics';

export const usePageTracking = () => {
  const location = useLocation();
  const { trackPageView, isInitialized } = useAnalytics();

  useEffect(() => {
    if (isInitialized) {
      // Only track page views after page is fully loaded
      const trackWhenReady = () => {
        setTimeout(() => {
          trackPageView(location.pathname);
        }, 2500); // Wait even longer for page view tracking
      };

      if (document.readyState === 'complete') {
        trackWhenReady();
      } else {
        window.addEventListener('load', trackWhenReady, { once: true });
      }
    }
  }, [location.pathname, isInitialized, trackPageView]);
};